import {useEffect, useState} from "react";

function upperCaseFirst(string) {
    const arr = string.split(" ");
    for (let i = 0; i < arr.length; i++) {
        arr[i] = arr[i].charAt(0).toUpperCase() + arr[i].slice(1);
    }
    return arr.join(" ")
}

export const clientIsDesktop = () => {
    return getClientType() == 'desktop';
}

export const getClientType = () => {
    // We moved /m2 to /m
    if (document.location.pathname.startsWith('/m/')) {
        return 'mobilev2';
    }
    else if (document.location.pathname.startsWith('/m2/')) {
        return 'mobilev2';
    }
    return 'desktop';
}

function uuidGen() {
    function s4() {
        return Math.floor((1 + Math.random()) * 0x10000)
            .toString(16)
            .substring(1);
    }

    return s4() + s4() + '-' + s4() + '-' + s4() + '-' + s4() + '-' + s4() + s4() + s4();
}

function isTouchDevice() {
    if ("ontouchstart" in document.documentElement) {
        return true;
    }
    return false;
}

const callAPI = (path, method, inputData) => {
    let init = {
        method: method || 'GET',
    }

    if ((method == 'POST' || method == 'PUT') && inputData) {
        init.body = JSON.stringify(inputData)
    }
    return fetch(path, init)
        .then(r => r.json())

}

const isElitefoto = () => {
    return window.NTLF_CONFIG.portal.uuid == '20efadfa-c17a-404e-919a-e463235482d5';
}

const useMetricSystem = () => {
    return window.NTLF_CONFIG.portal.locale.use_metric_system;

}

const useAPI = (path, method, inputData) => {
    const [loading, setLoading] = useState(true);
    const [data, setData] = useState(null);
    const [error, setError] = useState(null);

    // Will only trigger once
    useEffect(() => {
        setLoading(true);
        callAPI(path, method, inputData)
            .then(json => {
                setData(json)
            })
            .catch(err => {
                setError(err)
            })
            .finally(e => {
                console.log('Request complete')
                setLoading(false);
            })
    }, [path, inputData])
    return [data, loading, error];
}


function getImageSize(fillin, swidth, sheight, dwidth, dheight) {
    let diff = 0;
    let height = 0;
    let width = 0;
    let left = 0;
    let top = 0;

    var dratio = dwidth / dheight;
    var sratio = swidth / sheight;

    if (fillin == "fit-in") {
        if (dratio < sratio) {
            diff = dwidth / swidth;
            width = dwidth;
            height = diff * sheight;
        } else {
            diff = dheight / sheight;
            height = dheight;
            width = diff * swidth;
        }
        left = (dwidth / 2) - (width / 2);
        top = (dheight / 2) - (height / 2);
    } else {
        if (dratio > sratio) {
            diff = dwidth / swidth;
            width = dwidth;
            height = diff * sheight;
        } else {
            diff = dheight / sheight;
            height = dheight;
            width = diff * swidth;
        }
        left = (dwidth / 2) - (width / 2);
        top = (dheight / 2) - (height / 2);
    }

    return {
        left,
        top,
        width,
        height
    };
}

function getAllUrlParams(url) {

    // get query string from url (optional) or window
    var queryString = url ? url.split('?')[1] : window.location.search.slice(1);

    // we'll store the parameters here
    var obj = {};

    // if query string exists
    if (queryString) {

        // stuff after # is not part of query string, so get rid of it
        queryString = queryString.split('#')[0];

        // split our query string into its component parts
        var arr = queryString.split('&');

        for (var i = 0; i < arr.length; i++) {
            // separate the keys and the values
            var a = arr[i].split('=');

            // set parameter name and value (use 'true' if empty)
            var paramName = a[0];
            var paramValue = typeof (a[1]) === 'undefined' ? true : a[1];

            // (optional) keep case consistent
            paramName = paramName.toLowerCase();
            if (typeof paramValue === 'string') paramValue = paramValue.toLowerCase();

            // if the paramName ends with square brackets, e.g. colors[] or colors[2]
            if (paramName.match(/\[(\d+)?\]$/) || paramName.match(/%5b(\d+)?%5d$/)) {

                // create key if it doesn't exist
                var key = paramName.replace(/\[(\d+)?\]|%5b(\d+)?%5d$/, '');
                if (!obj[key]) obj[key] = [];

                // if it's an indexed array e.g. colors[2]
                if (paramName.match(/\[\d+\]$/)) {
                    // get the index value and add the entry at the appropriate position
                    var index = /\[(\d+)\]/.exec(paramName)[1];
                    obj[key][index] = paramValue;
                } else {
                    // otherwise add the value to the end of the array
                    obj[key].push(paramValue);
                }
            } else {
                // we're dealing with a string
                if (!obj[paramName]) {
                    // if it doesn't exist, create property
                    obj[paramName] = paramValue;
                } else if (obj[paramName] && typeof obj[paramName] === 'string') {
                    // if property does exist and it's a string, convert it to an array
                    obj[paramName] = [obj[paramName]];
                    obj[paramName].push(paramValue);
                } else {
                    // otherwise add the property
                    obj[paramName].push(paramValue);
                }
            }
        }
    }

    return obj;
}

export {
    uuidGen,
    isTouchDevice,
    getImageSize,
    useAPI,
    callAPI,
    isElitefoto,
    upperCaseFirst,
    getAllUrlParams,
    useMetricSystem
}